// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6063ab7","453":"cc194955","455":"001e8db9","952":"6a322ae7"}[chunkId] + ".chunk.js";
};